import type { DynamicTable } from '@/modules/dynamic_tables'

/** The three tables of the vehicle module, out of every dynamic table. */
export type VehicleTable =
  | DynamicTable.VEHICLE_DOCUMENTS
  | DynamicTable.VEHICLE_EXPIRATIONS
  | DynamicTable.VEHICLE_SERVICES

/**
 * Column ids shared by the vehicle lists. A list only declares the ones it
 * has, but a shared concept keeps the same id -- and so the same configured
 * header and position -- wherever it appears.
 */
export enum VehicleColumn {
  VEHICLE = 'vehicle',
  NAME = 'name',
  TYPE = 'type',
  DESCRIPTION = 'description',
  EXPIRATION_DATE = 'expirationDate',
  SCHEDULED_START = 'scheduledStart',
  SCHEDULED_END = 'scheduledEnd',
  STATUS = 'status',
  WORKSHOP_NAME = 'workshopName',
  COST = 'cost',
  TIME_SPENT = 'timeSpent',
  NOTIFICATION_TIME = 'notificationTime',
  RESPONSIBLE_USER = 'responsibleUser',
}

/** The row-menu column is structural, so it is never configurable. */
export const MENU_COLUMN_ID = 'menu'
